import React, { Component } from "react";
import TextField from "../../../components/inputs/textfield";
import Snackbar from "../../../components/snackbar/snackbar";
import Loader from "../../../components/loader/loader";
import { FormValidate } from "../../../components/formValidate";
import { admin_market_analysis_update, get_market_analysis_list } from "../admin.api";
import CustomButton from "../../../components/inputs/button";
import "./dialog.css";
let required = ["opportunity"];

class EditMarketAnalysis extends Component {
  constructor(props) {
    super(props);
    this.state = {
      formData: { opportunity: "" },
      isActive: false,
      snackMessage: "",
      isSnackError: false,
      snackOpen: false,
      submitted: false,
    };
  }

  componentDidMount() {
    this.fetchData();
  }

  fetchData = async () => {
    const { editData } = this.props;
    
    if (editData) {
      this.setState({ formData: editData });
    } else {
      // Fallback: fetch from list if no editData provided
      this.setState({ isActive: true });
      try {
        const res = await get_market_analysis_list();
        const list = Array.isArray(res) ? res : [];
        const row = list.find((x) => String(x?.id) === String(this.props.match?.params?.id));

        if (row) {
          this.setState({ formData: row });
        } else {
          this.setState({
            snackMessage: "Record not found",
            isSnackError: true,
            snackOpen: true,
          });
        }
      } catch (err) {
        this.setState({
          snackMessage: err?.response?.data?.message || err?.message || "Failed to fetch data",
          isSnackError: true,
          snackOpen: true,
        });
      } finally {
        this.setState({ isActive: false });
      }
    }
  };

  handleChange = (e) => {
    let value = e.target.value;
    let name = e.target.name;
    
    // Prevent space as first character
    if (name === 'opportunity' && value.length === 1 && value === ' ') {
      return;
    }
    
    // Trim leading spaces
    if (name === 'opportunity' && value.startsWith(' ')) {
      value = value.trimStart();
    }
    
    this.setState({ 
      formData: { ...this.state.formData, [name]: value } 
    });
  };

  snackbarClose = (flag) => {
    this.setState({
      snackMessage: "",
      isSnackError: false,
      snackOpen: false,
    });
    if (!flag) {
      this.props.handleClose();
    }
  };

  handleSubmit = (e) => {
    e.preventDefault();
    const error = FormValidate(this.state.formData, required);
    
    if (Object.keys(error).length === 0) {
      this.setState({ isActive: true });
      admin_market_analysis_update(this.state.formData?.id, { opportunity: this.state.formData?.opportunity })
        .then((res) => {
          this.setState({
            submitted: true,
            isActive: false,
          });
          if (this.props.handleClose) {
            this.props.handleClose(res.message);
          } else {
            this.setState({
              snackMessage: res.message,
              isSnackError: false,
              snackOpen: true,
            });
          }
        })
        .catch((error) => {
          this.setState({
            submitted: false,
            isActive: false,
            snackMessage: error.message,
            isSnackError: true,
            snackOpen: true,
          });
        });
    } else {
      this.setState({
        submitted: false,
        snackMessage: "Please fill all mandatory fields",
        isSnackError: true,
        snackOpen: true,
      });
    }
  };

  render() {
    const { submitted, formData, isActive } = this.state;
    const { open } = this.props;

    if (!open) return null;

    return (
      <React.Fragment>
        <Loader open={isActive} />
        <div className="overlay">
          <div className="big-dia-scroll dialog" style={{ height: 'auto', width: '30vw', overflowY: 'auto', minHeight: this.state.snackOpen ? '450px' : 'auto' }}>
            <Snackbar
              message={this.state.snackMessage}
              error={this.state.isSnackError}
              open={this.state.snackOpen}
              close={this.snackbarClose}
            />
            <div className=" d-flex flex-column justify-content-between h-100">
              <div>
                <div className="flexDisplay">
                  <div className="diaTitleCon">
                    Edit Market Analysis
                  </div>
                  <div className="dia-close" onClick={this.props.handleClose}>
                    <div className="diaCloseCon">
                      <div className="diaClose">&#10005;</div>
                    </div>
                  </div>
                </div>
                {/* <div className="tilebar d-flex justify-content-start">
                  <hr />
                </div> */}
              </div>
              <div style={{ overflowY: "auto" }}>
                <form>
                  <div className="row book-form" style={{ width: "100%" }}>
                    <div className="">
                      <div className="col-12">
                        <TextField
                          id="outlined-basic"
                          label="Opportunity"
                          variant="outlined"
                          onChange={(e) => this.handleChange(e)}
                          value={formData?.opportunity ?? ""}
                          name="opportunity"
                          required
                        />
                      </div>
                    </div>
                  </div>
                </form>
              </div>
              <div>
                <div className="col-12">
                  <CustomButton
                    label="Update"
                    disabled={submitted}
                    onClick={(e) => this.handleSubmit(e)}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default EditMarketAnalysis;
